var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSinglescaleOff = function SvgSinglescaleOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.86 27.039.875 32.917 11.934 43.84l11.059-10.923-5.985-5.878zm1.227 3h7.694l1.406 1.381H6.68zM6.666 34.42h10.536l-5.268 5.203zM37.734 5.115H20.775l-9.391 9.223 17.87 17.652 17.87-17.652zm-15.732 3h14.506l4.812 4.726H17.191zm-4.826 7.726h24.159l-12.08 11.932z"
  })))));
};
export default SvgSinglescaleOff;